<ng-container>
  @if (imageData$ | async; as imageData) {
    <mat-sidenav-container
      class="endorsements-sidenav-container">
      @if (digitizationParameters$ | async; as digitizationParameters) {
        <mat-sidenav [disableClose]="true"
          #sidenav
          mode="side"
          opened>

          <div class="endorsements-sidenav-container__header">Toolbox</div>
          <div class="endorsements-sidenav-container__endorsement-toolbox">
            <button mat-button
              [matMenuTriggerFor]="signatureMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <img src="assets/images/signature.png" alt="signature" />Signature
            </button>
            <mat-menu #signatureMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Signature:</p>
              @for (participant of getParticipants() | async; track participant) {
                <button
                  [disabled]="!participantCanParticipate(participant)"
                  (click)="handleGenerateEndorsementComponent({
              participant,
              imageData,
              isSystem: false,
              endorsementType: 'SIGNATURE'
            })"
                  mat-menu-item>
                  <img src="assets/images/signature.png" alt="signature" />
                  {{ participant | participantSignatureName }}
                  (<span>{{ participant.role | roleValue }}</span>)
                </button>
              }
            </mat-menu>
            <button mat-button
              [matMenuTriggerFor]="initialsMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <img src="assets/images/initials.png" alt="initials" />Initials
            </button>
            <mat-menu #initialsMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Initials:</p>
              @for (participant of getParticipants() | async; track participant) {
                <button
                  [disabled]="!participantCanParticipate(participant)"
                  (click)="handleGenerateEndorsementComponent({
              participant,
              imageData,
              isSystem: false,
              endorsementType: 'INITIALS'
            })"
                  mat-menu-item>
                  <img src="assets/images/initials.png" alt="initials" />
                  {{ participant | participantSignatureName }}
                  (<span>{{ participant.role | roleValue }}</span>)
                </button>
              }
            </mat-menu>
            <button mat-button
              [matMenuTriggerFor]="dateMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <img src="assets/images/date.png" alt="date" />Date
            </button>
            <mat-menu #dateMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Date:</p>
          <button (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'DATE',
                format: 'MM/dd/yyyy'
              })
            "
                mat-menu-item>
                <img src="assets/images/date.png" alt="date" />
                Full Date (MM/dd/yyyy)
              </button>
          <button (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'DATE',
                format: 'yyyy'
              })
            "
                mat-menu-item>
                <img src="assets/images/date.png" alt="date" />
                Four Digit Year (yyyy)
              </button>
          <button (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'DATE',
                format: 'yy'
              })
            "
                mat-menu-item>
                <img src="assets/images/date.png" alt="date" />
                Two Digit Year (yy)
              </button>
          <button (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'DATE',
                format: 'dd'
              })
            "
                mat-menu-item>
                <img src="assets/images/date.png" alt="date" />
                Day Of Month (dd)
              </button>
          <button (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'DATE',
                format: 'MMMM'
              })
            "
                mat-menu-item>
                <img src="assets/images/date.png" alt="date" />
                Month Name (January)
              </button>
          <button (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'DATE',
                format: 'MMM'
              })
            "
                mat-menu-item>
                <img src="assets/images/date.png" alt="date" />
                Month Abbreviated (Jan)
              </button>
          <button (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'DATE',
                format: 'MM'
              })
            "
                mat-menu-item>
                <img src="assets/images/date.png" alt="date" />
                Month Number (MM)
              </button>
            </mat-menu>
            <button mat-button
              [matMenuTriggerFor]="textboxMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <img src="assets/images/textbox.png" alt="textbox" />Textbox
            </button>
            <mat-menu #textboxMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Textbox:</p>
              <mat-divider></mat-divider>
              <p>Required</p>
              @for (participant of getParticipants() | async; track participant) {
                <button
                  [disabled]="!participantCanParticipate(participant)"
                  (click)="handleGenerateEndorsementComponent({
                  participant,
                  imageData,
                  isSystem: false,
                  endorsementType: 'TEXTBOX'
                })"
                  mat-menu-item>
                  <img src="assets/images/textbox.png" alt="textbox" />
                  {{ participant | participantSignatureName }}
                  (<span>{{ participant.role | roleValue }}</span>)
                </button>
              }
              <mat-divider></mat-divider>
              <p>Optional</p>
              @for (participant of getParticipants() | async; track participant) {
                <button
                  [disabled]="!participantCanParticipate(participant)"
                  (click)="handleGenerateEndorsementComponent({
                  participant,
                  imageData,
                  isSystem: false,
                  endorsementType: 'TEXTBOX',
                  isRequired: false
                })"
                  mat-menu-item>
                  <img src="assets/images/textbox.png" alt="textbox" />
                  {{ participant | participantSignatureName }}
                  (<span>{{ participant.role | roleValue }}</span>)
                </button>
              }
            </mat-menu>
            <button mat-button
              [matMenuTriggerFor]="checkboxMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <img src="assets/images/checkbox.png" alt="checkbox" />Checkbox
            </button>
            <mat-menu #checkboxMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Checkbox:</p>
              <mat-divider></mat-divider>
              <p>Required</p>
              @for (participant of getParticipants() | async; track participant) {
                <button
                  [disabled]="!participantCanParticipate(participant)"
                  (click)="handleGenerateEndorsementComponent({
                  participant,
                  imageData,
                  isSystem: false,
                  endorsementType: 'CHECKBOX'
                })"
                  mat-menu-item>
                  <img src="assets/images/checkbox.png" alt="checkbox" />
                  {{ participant | participantSignatureName }}
                  (<span>{{ participant.role | roleValue }}</span>)
                </button>
              }
              <mat-divider></mat-divider>
              <p>Optional</p>
              @for (participant of getParticipants() | async; track participant) {
                <button
                  [disabled]="!participantCanParticipate(participant)"
                  (click)="handleGenerateEndorsementComponent({
                  participant,
                  imageData,
                  isSystem: false,
                  endorsementType: 'CHECKBOX',
                  isRequired: false
                })"
                  mat-menu-item>
                  <img src="assets/images/checkbox.png" alt="checkbox" />
                  {{ participant | participantSignatureName }}
                  (<span>{{ participant.role | roleValue }}</span>)
                </button>
              }
            </mat-menu>
            <button mat-button
              class="endorsements-sidenav-container__endorsement-toolbox__item"
                (click)="
            handleGenerateEndorsementComponent({
              participant: null,
              imageData,
              isSystem: true,
              endorsementType: 'STATE'
            })
          ">
              <img src="assets/images/state.png" alt="state" />State
            </button>
            <button mat-button
              [disabled]="endorsmentDisabledForOrder()"
              [matMenuTriggerFor]="commisionFieldsMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <img src="assets/images/commission-fields.png" alt="commission fields" />Commission Fields
            </button>
            <mat-menu #commisionFieldsMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Commission Fields:</p>
              <button [disabled]="endorsmentDisabledForOrder()"
                  (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'SIGNINGAGENTCOMMEXPIRE'
              })
            "
                mat-menu-item>
                <img src="assets/images/commission-fields.png" alt="commission expiration" />
                Commission Expiration Date
              </button>
              <button [disabled]="endorsmentDisabledForOrder()"
                  (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'SIGNINGAGENTCOMMNUMBER'
              })
            "
                mat-menu-item>
                <img src="assets/images/commission-fields.png" alt="commission number" />
                Commission Number
              </button>
              <button [disabled]="endorsmentDisabledForOrder()"
                  (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'SIGNINGAGENTCOMMCOUNTY'
              })
            "
                mat-menu-item>
                <img src="assets/images/commission-fields.png" alt="commission county" />
                Commission County
              </button>
              <button [disabled]="endorsmentDisabledForOrder()"
                  (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'SIGNINGAGENTCOMMSTATE'
              })
            "
                mat-menu-item>
                <img src="assets/images/commission-fields.png" alt="commission state" />
                Commission State
              </button>
            </mat-menu>
            @if (getParticipants() | async; as participants) {
              <button [disabled]="endorsmentDisabledForOrder()"
                mat-button
                class="endorsements-sidenav-container__endorsement-toolbox__item"
                (click)="handleGenerateNotaryEndorsementComponent({
            participants,
            imageData
          })">
                <img src="assets/images/stamp.png" alt="stamp" />Stamp
              </button>
            }
            <button mat-button
              [disabled]="endorsmentDisabledForOrder()"
              [matMenuTriggerFor]="signingAgentFieldsMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <img src="assets/images/saf.png" alt="signing agent fields" />Signing Agent Fields
            </button>
            <mat-menu #signingAgentFieldsMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Signing Agent Fields:</p>
              <button [disabled]="endorsmentDisabledForOrder()"
                  (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'SIGNINGAGENTCOUNTY'
              })
            "
                mat-menu-item>
                <img src="assets/images/saf.png" alt="signing agent county" />
                Signing Agent County
              </button>
              <button [disabled]="endorsmentDisabledForOrder()"
                  (click)="
              handleGenerateEndorsementComponent({
                participant: null,
                imageData,
                isSystem: true,
                endorsementType: 'SIGNINGAGENTNAME'
              })
            "
                mat-menu-item>
                <img src="assets/images/saf.png" alt="signing agent name" />
                Signing Agent Name
              </button>
            </mat-menu>
            <button mat-button
              [matMenuTriggerFor]="printedNameMenu"
              class="endorsements-sidenav-container__endorsement-toolbox__item">
              <i class="fa fa-font" aria-hidden="true"></i>Printed Name
            </button>
            <mat-menu #printedNameMenu="matMenu"
              class="mat-elevation-z24"
              overlapTrigger
              xPosition="after"
              yPosition="below">
              <p>Select Printed Name:</p>
              @for (participant of getParticipants() | async; track participant) {
                <button
                  [disabled]="!signingAgent(participant)"
                  (click)="handleGenerateEndorsementComponent({
              participant,
              imageData,
              isSystem: false,
              endorsementType: 'PRINTEDNAME'
            })"
                  mat-menu-item>
                  <i class="fa fa-font" aria-hidden="true"></i>{{
                  participant | participantSignatureName
                  }}
                  (<span>{{ participant.role | roleValue }}</span>)
                </button>
              }
            </mat-menu>
          </div>
          <div>
            <button (click)="handleSubmitDocumentAndEndorsements({ imageData, digitizationParameters })"
              class="btn-primary btn-save"
              aria-label="Save all document and endorsement changes"
              [disabled]="!(canDigitize$ | async)">
              Save Changes
            </button>
          </div>
          <div class="endorsements-sidenav-container__templates">
            <div class="endorsements-sidenav-container__header">
              <mat-label>
                <p class="mt-10 float-start">Templates</p>
                <button mat-button [matMenuTriggerFor]="templateHelpMenu" class="mt-1" aria-label="Show template help information">
                  <img src="assets/icons/helpOutline.svg" alt="help" />
                </button>
                <button 
                  type="button"
                  class="btn-secondary ms-1" 
                  style="font-size: 11px; padding: 3px 8px; height: 24px; line-height: 1.2;"
                  (click)="handleOpenTemplateShareModal()"
                  title="Import or Export templates"
                  aria-label="Import or Export templates">
                  Import/Export
                </button>
              </mat-label>
              <mat-menu #templateHelpMenu="matMenu"
                class="mat-elevation-z24"
                overlapTrigger
                xPosition="after"
                yPosition="below">
                <b>Endorsement Templates</b>
                <p>
                  Select an endorsement template to apply the endorsements in the same places on your         
                  current document. Use Import/Export to share templates between accounts.
                </p>
              </mat-menu>
            </div>
            <mat-form-field appearance="fill"
              class="endorsements-sidenav-container__templates__form"
              id="digiDocTemplateId">
              <mat-label>Apply Template</mat-label>
          <mat-select (selectionChange)="
              handleGenerateEndorsementsUsingTemplate({
                templateId: $event.value,
                imageData
              })
            "
                [(value)]="digitizationParameters.selectedTemplate"
                data-cy="selectTemplateDropdown"
                aria-label="Select endorsement template to apply">
                @if ((templateOptions$ | async).length === 0) {
                  <mat-option disabled>
                    No Templates Created
                  </mat-option>
                }
                @for (template of templateOptions$ | async; track template.key) {
                  <mat-option [value]="template.key">
                    {{ template.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (templateID) {
              <div class="ms-3 mb-3">Template ID: {{ templateID }}</div>
            }
            <div>
              @if (getParticipants() | async; as participants) {
                <button
                  (click)="handleOpenSaveTemplateModalForTemplateName({digitizationParameters, imageData, participants })"
                  class="btn-secondary btn-save"
                  aria-label="Save current endorsements as new template">
                  Save Template As
                </button>
              } @else {
                <button [disabled]
                  class="btn-secondary btn-save"
                  aria-label="Save template as (disabled - no participants)">
                  Save Template As
                </button>
              }
              @if (
                getParticipants() | async; as participants) {
                <button
                  (click)="
              handleUpdateTemplateEndorsements({
                imageData,
                digitizationParameters,
                templateId: digitizationParameters.selectedTemplate,
                participants
              })
            "
                  class="btn-primary btn-save"
                  aria-label="Save changes to current template">
                  Save Template Changes
                </button>
              } @else {
                <button [disabled]
                  class="btn-primary btn-save"
                  aria-label="Save template changes (disabled - no participants)">
                  Save Template Changes
                </button>
              }
              <button
                [disabled]="!digitizationParameters.selectedTemplate"
                (click)="handleDeleteTemplateConfirmation(digitizationParameters.selectedTemplate)"
                class="btn-secondary-warning btn-save"
                aria-label="Delete selected template">
                Delete Template
              </button>
            </div>
          </div>
        </mat-sidenav>
      }
    </mat-sidenav-container>
  }
</ng-container>
